import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import Div from '../Page/Div';
import FixedContainer from '../Page/FixedContainer';
import { sanitize } from '../../utils';
import usePageStore from '../Page/pageStore';
const SolutionsHeader = ({ content, idx, allowOpen, }) => {
    const { activeSection } = usePageStore();
    const { title, details } = content.solutions_header;
    useEffect(() => {
        // only set background animation shift on the first header section
        // !activeSection means no shift
        if (idx === 0) {
            if (activeSection) {
                document.body.classList.add('shift-mobile-background');
            }
            else {
                document.body.classList.remove('shift-mobile-background');
            }
        }
    }, [activeSection]);
    return (_jsx(FixedContainer, { idx: idx, allowOpen: allowOpen, parentClassName: `solutions-header-container`, sliderClassName: `solutions-header-wrapper`, children: [
            title ? (_jsx(Div, { blocked: !allowOpen, className: "solutions-header-title", delay: 0, noScale: true, children: title }, "0")) : null,
            _jsx(Div, { blocked: !allowOpen, className: "solutions-header-details", delay: title ? 1 : 0, noScale: true, children: _jsx("div", { dangerouslySetInnerHTML: {
                        __html: sanitize(details),
                    } }) }, "1"),
        ] }));
};
export default SolutionsHeader;
